import { Pipe, PipeTransform } from '@angular/core';
import { StatesPluginService } from './states-plugin.service';

@Pipe({
    name: 'stateprioritypipe',
    standalone: false
})
export class StatePriorityPipe implements PipeTransform {
  public priorities: any;

  constructor(private service: StatesPluginService) {
    this.priorities = this.service.getPriorities();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.priorities);
  }
}
